
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class IndividualColorMixin extends Vue {
  @Prop() mainColor!: string

  get colorStyle () {
    return {
      color: this.mainColor
    }
  }
}
